module.exports = __webpack_public_path__ + "assets/img/calculator.518ab72e.jpg";